import { useState } from "react";

function CollapsibleSection({ title, defaultOpen = false, children }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="CollapsibleSection" style={{ marginBottom: "8px" }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          background: "rgba(255,255,255,0.05)",
          borderRadius: isOpen ? "8px 8px 0 0" : "8px",
          cursor: "pointer",
          userSelect: "none",
          borderBottom: isOpen ? "1px solid rgba(255,255,255,0.08)" : "none"
        }}
      >
        <span style={{ fontWeight: "500", fontSize: "15px" }}>{title}</span>
        <span style={{ fontSize: "12px", opacity: 0.6 }}>
          {isOpen ? "▼ collapse" : "▶ expand"}
        </span>
      </div>

      {isOpen && (
        <div style={{
          padding: "16px",
          background: "rgba(255,255,255,0.03)",
          borderRadius: "0 0 8px 8px",
        }}>
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;